import React from "react";
import Banner from "./Banner";
import { makeStyles } from '@material-ui/core';
import { getCiaFromUrl } from '@portal/arq-portal-core';

const useEstilos = makeStyles(() => ({
    banner2: {
        display: 'flex',
        justifyContent: 'space-between',
        '& .banner2-wrapper': {
            position: 'relative', 
            display: 'inline-block', 
            width: "calc(50% - 15px)",
            '@media screen and (max-width: 767px)': {
                width: "calc(50% - 5px)",
            },
        }
    }
}));

export default function Banner2(props: {pub1: any, pub2:any}){
    const classes = useEstilos(props);

    const cia = getCiaFromUrl();

    var bannersimpledefault = 'assets/bannersimple.png';

    switch(cia){
        case 'SBI': 
            bannersimpledefault = 'assets/bannersimple_SB.png';
            break;
        case 'SPU':
            bannersimpledefault = 'assets/bannersimple_PU.png';
            break;
        case 'NH':
            bannersimpledefault = 'assets/bannersimple_NH.png';
            break;
        case 'PRE':
            bannersimpledefault = 'assets/bannersimple_PRS.png';
            break;
        case 'AIE':
            bannersimpledefault = 'assets/bannersimple_AIE.png';
            break;
        case 'OCC':
            bannersimpledefault = 'assets/bannersimple_OCC.png';
            break;
        default:
            bannersimpledefault = 'assets/bannersimple.png';
            break;
    }

    const defaultImage = <img src={bannersimpledefault} alt='Imagen de carga'></img>;

    return (
        <div className={classes.banner2} >
            {props.pub1 && <div className="banner2-wrapper">
                <Banner publicacion={props.pub1} defaultImage={defaultImage} tipo="BS"></Banner>
            </div>}
            {props.pub2 && <div className="banner2-wrapper">
                <Banner publicacion={props.pub2} defaultImage={defaultImage} tipo="BS"></Banner>
            </div>}
        </div>
    ) 
}